/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgWalletAdjustment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <rect width={40} height={40} fill="currentColor" rx={20} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M14 8a1 1 0 0 0-1 1v1h-3a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12.343A8.983 8.983 0 0 1 19 23a8.983 8.983 0 0 1 3.343-7H10v-4h3v1a1 1 0 1 0 2 0v-1h7.991v1a1 1 0 1 0 2 0v-1H28v2c.687 0 1.357.077 2 .223V12a2 2 0 0 0-2-2h-3.009V9a1 1 0 1 0-2 0v1H15V9a1 1 0 0 0-1-1Zm-4 11.5v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1Zm0 5.5v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1Zm5-5.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1Zm0 5.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M28 30a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm-1.968-5.258-.793 1.11a4.9 4.9 0 0 0 1.098.756c.398.188.837.31 1.317.366v.854h.854v-.83a3.178 3.178 0 0 0 1.037-.231c.31-.138.57-.305.781-.5a2.15 2.15 0 0 0 .488-.695c.114-.26.17-.533.17-.818 0-.382-.085-.712-.255-.988a2.488 2.488 0 0 0-.635-.732 4.387 4.387 0 0 0-.866-.525 12.54 12.54 0 0 0-.915-.39l-.159-.061a18.389 18.389 0 0 0-.475-.183 2.71 2.71 0 0 1-.403-.22 1.15 1.15 0 0 1-.28-.28.684.684 0 0 1-.098-.366c0-.098.024-.191.073-.28a.933.933 0 0 1 .232-.245c.106-.073.24-.13.402-.17.163-.05.354-.07.574-.062.163 0 .33.02.5.061.179.041.346.094.5.159.163.057.31.118.44.183.138.065.247.13.329.195l.756-1.073a3.115 3.115 0 0 0-.366-.257 3.435 3.435 0 0 0-.488-.256 2.976 2.976 0 0 0-.61-.22 3.78 3.78 0 0 0-.732-.134v-.634h-.854v.659c-.35.049-.659.142-.927.28-.26.139-.48.305-.659.5-.17.196-.3.411-.39.647-.09.228-.134.456-.134.683 0 .383.069.704.207.964.146.252.334.472.561.659.236.179.505.33.805.451.301.122.61.24.928.354.122.049.272.106.451.17.179.066.346.147.5.245.163.097.301.211.415.341a.68.68 0 0 1 .17.464c0 .277-.121.496-.365.659-.244.154-.57.236-.976.244a2.908 2.908 0 0 1-1.122-.183c-.334-.138-.696-.362-1.086-.671Z"
      clipRule="evenodd"
    />
  </svg>
)
const Memo = memo(SvgWalletAdjustment)
export default Memo
